import { call, takeLatest, select, put } from 'redux-saga/effects';
import { AxiosResponse } from 'axios';
import { makeBackendApi, IOffersListResponse } from 'services/BackendApi';
import { offersListQuerySelector } from '../selectors';
import {
  GET_OFFERS_LIST_REQUEST,
  SET_FILTER,
  SET_SORT,
  SET_PAGE_NUMBER,
  SET_TRAVEL_AGENT_UUID,
  SET_SELECTED_HOTEL,
  getOffersListSuccessAction,
  getOffersListFailureAction,
} from '../actions';
import { selectedTaSelector } from '../../agents';

export function* getOffersListSaga(action: any) {
  try {
    const selectedTa = yield select(selectedTaSelector);
    const backendApi = makeBackendApi(selectedTa?.uuid);
    const query = yield select(offersListQuerySelector);
    const result: AxiosResponse<IOffersListResponse> = yield call(backendApi.getOffersList, query);
    yield put(getOffersListSuccessAction(result.data.data, result.data.meta.total));
  } catch (e) {
    yield put(getOffersListFailureAction(e));
  }
}

export function* watchGetOffersList() {
  yield takeLatest(
    [GET_OFFERS_LIST_REQUEST, SET_FILTER, SET_SORT, SET_PAGE_NUMBER, SET_TRAVEL_AGENT_UUID, SET_SELECTED_HOTEL],
    getOffersListSaga
  );
}
